<template>
  <v-row aling="center" justify="start" class="mx-0">

    <!-- skeleton loader -->
    <template v-if="$store.state.payments.retrieveLoader">
      <v-col cols="3" v-for="i in 4" :key="i">
        <v-skeleton-loader transition="fade-transition" type="article, actions" />
      </v-col>
    </template>
    <!-- end skeleton loader -->

    <!-- gateways -->
    <template v-else>
      <v-col cols="2" v-for="d in gateways" :key="d.id">
        <v-card class="py-0 card-apps" @click.stop="dialog=true, provider.gateway=d.id" :ripple="false">
          <v-card-text class="px-2 text-center">
            <v-responsive class="align-center" :aspect-ratio="6/4">
              <img class="mt-4" :src="require(`@/assets/appAsset-brand--${d.id}.svg`)" height="36px" />
            </v-responsive>
            <v-chip v-if="providers.includes(d.id)" color="lightBlue" text-color="primary" small>Conectado</v-chip>
            <v-chip v-else color="white" text-color="white" small></v-chip>
          </v-card-text>
        </v-card>
      </v-col>
    </template>
    <!-- end gateways -->

    <!-- dialog connect gateway -->
    <v-dialog v-model="dialog" width="900" persistent no-click-animation scrollable>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">{{`Conectar ${selectedProvider.name}`}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn class="ml-3" @click="dialog=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-row no-gutters>
            <v-col cols="4" style="border-right: 1px solid #D8E0EA">
              <v-card class="ma-4" width="120px" outlined >
                <v-card-text>
                  <v-responsive class="align-center" :aspect-ratio="1/1">
                    <img :src="selectedProvider.id ? require(`@/assets/appAsset-brand--${selectedProvider.id}.svg`) : ''" :alt="selectedProvider.id" width="100%">
                  </v-responsive>
                </v-card-text>
              </v-card>
              <v-list class="pb-4">
                <v-list-item>
                  <v-list-item-content>{{selectedProvider.description}}</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="d-block text--secondary font-weight-medium">Compatibilidad</v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Pagos</v-list-item-title>
                    <v-list-item-subtitle class="pt-1">
                      <code class="mr-1 body-2 text--secondary background" v-if="selectedProvider.allow_single_use">únicos</code>
                      <code class="mr-1 body-2 text--secondary background" v-if="selectedProvider.allow_reusable_use">recurrentes</code>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Monedas</v-list-item-title>
                    <v-list-item-subtitle class="pt-1">
                      <code class="mr-1 body-2 text--secondary background" v-for="currency in selectedProvider.currencies" :key="currency">{{currency}}</code>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="8" class="background">
              <v-list class="py-5 transparent">
                <v-list-item class="py-1">
                  <v-list-item-content>
                    <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">{{commerceCodeName}}</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field v-model="$v.provider.commerce_code.$model" :error="$v.provider.commerce_code.$error" background-color="white" outlined required single-line dense maxlength="254" :placeholder="selectedProvider.placeholder" hide-details />
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <!-- khipu -->
                <v-list-item v-if="provider.gateway === 'khipu'">
                  <v-list-item-content>
                    <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Llave</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field v-model="$v.provider.extra_data.secret.$model" :error="$v.provider.extra_data.secret.$error" background-color="white" outlined required single-line dense hide-details />
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- end khipu -->

                <!-- paypal -->
                <v-list-item v-if="provider.gateway === 'paypal'">
                  <v-list-item-content>
                    <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Client secret</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field v-model="$v.provider.extra_data.secret.$model" :error="$v.provider.extra_data.secret.$error" background-color="white" outlined required single-line dense  hide-details />
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- end paypal -->

                <!-- stripe -->
                <v-list-item v-if="['stripe', 'twocheckout'].includes(provider.gateway)">
                  <v-list-item-content>
                    <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Secret key</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field v-model="$v.provider.extra_data.secret.$model" :error="$v.provider.extra_data.secret.$error" background-color="white" outlined required single-line dense hide-details />
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- end stripe -->

                <!-- mercadopago -->
                <v-list-item v-if="provider.gateway === 'mercadopago'">
                  <v-list-item-content>
                    <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Access token</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field v-model="$v.provider.extra_data.secret.$model" :error="$v.provider.extra_data.secret.$error" background-color="white" outlined required single-line dense hide-details />
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- end mercadopago -->

                <v-list-item class="py-1">
                  <v-list-item-content>
                    <v-btn :href="`${$DOCS_BASE}${selectedProvider.guide}`" target="_blank" text color="primary">Ir a la guía de configuración<v-icon right small>mdi-open-in-new</v-icon></v-btn>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="pt-16" v-if="selectedProvider.warning">
                  <v-list-item-content>
                    <v-alert class="mb-0 body-2" dark dense color="primary" border="left" type="info">{{selectedProvider.warning}}</v-alert>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-btn v-if="providers.includes(selectedProvider.id)" @click="destroyProvider" dark color="red">Desconectar</v-btn>
          <v-spacer />
          <v-btn @click="dialog=false, $v.provider.$reset()" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="createProvider" :loading="$store.state.payments.createLoader" color="primary">Conectar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog connect gateway -->

  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'

import GenericViewMixin from '@/mixins/GenericViewMixin'
import gateways from '../../collections/gateways'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    commerceCodeNames: {
      oneclick: 'Código de comercio',
      webpay: 'Código de comercio',
      khipu: 'ID de Cobrador',
      paypal: 'Client ID',
      stripe: 'Public key',
      mercadopago: 'Public key'
    },
    dialog: false,
    gateways: gateways,
    provider: {
      gateway: '',
      commerce_code: '',
      extra_data: {
        secret: ''
      }
    }
  }),
  computed: {
    ...mapState({
      providersList: state => state.payments.providersList
    }),
    commerceCodeName () {
      return this.commerceCodeNames[this.provider.gateway] || 'Commerce code'
    },
    providers () {
      return this.providersList.map(provider => provider.gateway)
    },
    selectedProvider () {
      const base = {
        id: '',
        title: '',
        description: '',
        url: '',
        usages: [],
        currencies: []
      }
      return this.gateways.find(provider => provider.id === this.provider.gateway) || base
    }
  },
  created () {
    this.$store.dispatch('payments/LIST', {
      resource: 'providers'
    })
  },
  methods: {
    createProvider () {
      this.$v.provider.$touch()
      if (this.$v.provider.$invalid) {
        return false
      }
      this.$store.dispatch('payments/CREATE', {
        resource: 'providers',
        payload: this.provider
      })
      .then(() => {
        this.$dialog.message.info(`Tu cuenta de ${this.provider.gateway} se ha conectado`)
        this.dialog = false
        this.provider = {
          gateway: '',
          commerce_code: '',
          extra_data: {
            secret: ''
          }
        }
        this.$v.provider.$reset()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    destroyProvider () {
      this.$dialog.warning({
        title: 'Desconectar cuenta',
        text: `
          <span class="d-block my-4">¿Estás seguro de desconectar este proveedor de pagos?</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('payments/DESTROY', {
                resource: 'providers',
                id: this.selectedProvider.id
              })
              .then(() => {
                this.$dialog.message.info(`La cuenta de ${this.selectedProvider.id} se ha desconectado`)
                this.dialog = false
              })
              .catch((error) => {
                this.$dialog.message.warning(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    }
  },
  validations: {
    provider: {
      gateway: {
        required
      },
      commerce_code: {
        required,
        maxLength: maxLength(254)
      },
      extra_data: {
        secret: {
          required: requiredIf(function () {
            return ['paypal', 'khipu', 'stripe', 'twocheckout', 'mercadopago'].includes(this.provider.gateway)
          }),
          maxLength: maxLength(254)
        }
      }
    }
  }
}
</script>